(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectTypesMappingDialogController', TabObjectTypesMappingDialogController);

    TabObjectTypesMappingDialogController.$inject = ['$state', '$scope', '$rootScope', 'entity', 'TabObjectTypes'];

    function TabObjectTypesMappingDialogController($state, $scope, $rootScope, entity, TabObjectTypes) {

        var vm = this;

        vm.template = entity;
        vm.property = [];
        vm.createObj = false;
        vm.quantity = 0;
        vm.properties = [];

        vm.clear = function () {
            $state.go('^');
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabObjectTypesUpdate', result);
            vm.isSaving = false;
            $state.go('tab-object-types-mapping');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            if(!vm.createObj){
                var properties = {};
                properties[vm.property.name] = {type: vm.property.type};
                var body = {
                    id: vm.template.id,
                    index: "jot_"+vm.template.objectTypeName.toLowerCase()+"_template",
                    properties: properties
                };
                TabObjectTypes.putTemplate(body, onSaveSuccess, onSaveError);
            } else {
                var app = {};
                for(var i = 0; i < vm.properties.length; i++){
                    if(vm.properties[i].type != "object") {
                        app[vm.properties[i].name] = {type: vm.properties[i].type};
                    } else {
                        app[vm.properties[i].name] = angular.fromJson(vm.properties[i].objectJson);
                    }
                }
                var body = {
                    id: vm.template.id,
                    index: "jot_"+vm.template.objectTypeName.toLowerCase()+"_template",
                    properties: app
                };
                TabObjectTypes.putTemplate(body, onSaveSuccess, onSaveError);
            }
        };
    }
})();
